import { Button, Dropdown, Menu } from "antd"
import { SortIcon } from "components-old/icons"
import Tooltip from "components-old/Tooltip"
import MenuItemInnerSelectable from "components-old/ui/SearchDrop/MenuItemInnerSelectable"
import { cn } from "lib/utils"
import { memo } from "react"

export interface SorterDropdownProps<T> {
  selected: string
  setSelected: (id: string) => void
  title?: string
  sorters: {
    id: string
    label: string
    sorter: (a: T, b: T) => number
  }[]
}

function SorterDropdown<T>(props: SorterDropdownProps<T>) {
  const option = props.sorters.find((option) => option.id === props.selected)

  const isFiltering = !!option && option?.id !== props.sorters?.[0]?.id

  const content = (
    <Tooltip title={props.title || "Ordenar por"}>
      <Button
        type="text"
        className={cn("rounded-xl size-7 opacity-50 hover:opacity-100", isFiltering && "!opacity-100 !bg-selected-lighter")}
        icon={<SortIcon className="!size-[18px]" />}
      >
        {/* {option?.label}
      <i className="ml-2 text-xs fas fa-caret-down" /> */}
      </Button>
    </Tooltip>
  )

  return (
    <Dropdown
      overlay={
        <Menu>
          {props.sorters.map((option, i) => {
            return <SorterDropdownItem key={option.id} option={option} selected={props.selected} setSelected={props.setSelected} />
          })}
        </Menu>
      }
      trigger={["click"]}
    >
      <span>
        {props.title ? (
          <Tooltip title={props.title || "Segmento"} side="bottom">
            {content}
          </Tooltip>
        ) : (
          content
        )}
      </span>
    </Dropdown>
  )
}

const SorterDropdownItem = memo((props: { option: any; selected: string; setSelected: (value: string) => void }) => {
  return (
    <Menu.Item
      key={props.option.id}
      onClick={(e) => {
        props.setSelected(props.option.id)
      }}
    >
      <MenuItemInnerSelectable selected={props.selected == props.option.id} title={props.option.label}>
        {props.option.label}
      </MenuItemInnerSelectable>
    </Menu.Item>
  )
})

export default SorterDropdown
